// src/modules/MyPanel/Modal/components/HeaderMyPanel.tsx
import React from "react";
import { UserIcon, InformationIcon } from "../../../../components/Icons";
import { StyledFlexDiv, StyledCenterDiv } from "../../../../styles/MainStyles";
import { StyledIconInfo } from "../../../../styles/pages/MyPanel/ModalDetailsMyPanelStyles";
import {
    StyledTitle,
    StyledSubTitle,
} from "../../../../styles/pages/MyPanel/ModalInformation";
import {
    StyledCardTag,
    StyledModalTitle,
} from "../../../../styles/pages/MyPanel/ModalInfoMyPanelStyles";
import GenericUtils from "../../../../utils/GenericUtils";

const user = GenericUtils.getUser();
const matriculaADP = GenericUtils.getUserAdp();

interface HeaderMyPanelProps {
    text?: string;
    title: string;
    subtitle?: string;
    warning?: string;
}

const HeaderMyPanel: React.FC<HeaderMyPanelProps> = ({
    text,
    title,
    subtitle,
    warning,
}) => {
    return (
        <StyledCenterDiv style={{ flexDirection: "column", gap: 12 }}>
            {text && <StyledCardTag>{text}</StyledCardTag>}

            <StyledModalTitle>{title}</StyledModalTitle>
            {subtitle && <StyledSubTitle>{subtitle}</StyledSubTitle>}
            {warning && (
                <StyledSubTitle style={{ color: "#8A0538", fontWeight: 600 }}>
                    {warning}
                </StyledSubTitle>
            )}
            <StyledFlexDiv>
                {user && user.docente && user.docente.nome && (
                    <StyledIconInfo>
                        <UserIcon />
                        <span>{`Professor(a) ${user.docente.nome}`}</span>
                    </StyledIconInfo>
                )}
                {matriculaADP && (
                    <StyledIconInfo>
                        <InformationIcon />
                        <span>{`Matrícula: ${matriculaADP}`}</span>
                    </StyledIconInfo>
                )}
            </StyledFlexDiv>
        </StyledCenterDiv>
    );
};

export default HeaderMyPanel;
